<template>
  <div id="app">
    <AppHeader></AppHeader>
    <div class="wrapper">
      <transition name="fade">
        <b-container fluid class="mt-3">
          <b-nav tabs v-if="$route.name !== 'login'">
            <b-nav-item @click="goToHome()">Inicio</b-nav-item>
            <b-nav-item @click="goToSchedule()" v-if="this.$store.state.user.currentGroups.includes('Dirección')">Horarios</b-nav-item>
            <b-nav-item @click="goToClasses()">Clases</b-nav-item>
            <b-nav-item @click="goToFamilies()" v-if="this.$store.state.user.currentGroups.includes('Dirección')">Familias</b-nav-item>
            <b-nav-item @click="goToEnrollments()" v-if="this.$store.state.user.currentGroups.includes('Dirección')">Inscripciones</b-nav-item>
            <b-nav-item @click="goToBilling()" v-if="this.$store.state.user.currentGroups.includes('Dirección')">Facturacion</b-nav-item>
            <b-nav-item @click="goToConfig()" v-if="this.$store.state.user.currentGroups.includes('Dirección')">Configuracion</b-nav-item>
          </b-nav>
          <b-row class="p-3">
            <b-col><router-view></router-view></b-col>
          </b-row>
        </b-container>
      </transition>
    </div>
  </div>
</template>

<script>

import AppHeader from './Header.vue'

export default {
  name: 'AppLayout',
  components: {
    AppHeader
  },

  data () {
    return {
      groups: this.$store.state.user.currentGroups
    }
  },
  async created () {
  },
  methods: {
    goToHome () {
      this.$router.push('/')
    },
    goToSchedule () {
      this.$router.push('/schedule')
    },
    goToClasses () {
      this.$router.push('/classes')
    },
    goToFamilies () {
      this.$router.push('/families')
    },
    goToEnrollments () {
      this.$router.push('/enrollments')
    },
    goToBilling () {
      this.$router.push('/billing')
    },
    goToConfig () {
      this.$router.push('/config')
    }
  }
}
</script>s
